module.exports = {"341722100":"仁里镇","341722101":"七都镇","341722102":"仙寓镇","341722103":"丁香镇","341722104":"小河镇","341722105":"横渡镇","341722200":"大演乡","341722201":"矶滩乡","341722401":"池州经济技术开发区石台工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341722.json
// module id = 1258
// module chunks = 0